const en_purch_po = {
    "": "purchase order",
    create: "create purchase order",
    edit: "edit purchase order",
    currency: "currency",
    additional_cost: "additional cost",
    additional_discount: "additional discount",
    price_history: "price history",
    po_detail: "purchase order detail",
    do: 'create item in',

    create_mitra: "create partner purchase order",
    edit_mitra: "edit partner purchase order",

    dp_record: "down payment record",

    label: {
        exchange_rate: "exchange rate (IDR)",
        btn_dp: "record down payment",
    },

    message: {
        dp_note: "A down payment has been made on {{date}} with an amount of {{nominal}}",
        conf_dp_title: "Cancel DP",
        conf_dp_text: "Are you sure you want to cancel DP?",

        delete_po_title: "Are you sure you want to cancel PO?",
        delete_po_text: "Enter the reason for cancelling PO.",

        reject_po_title: "Are you sure you want to cancel PO?",
        reject_po_text: "Enter the reason for cancelling PO.",

        reject_do_title: "Are you sure you want to cancel DO?",
        reject_do_text: "Enter the reason for cancelling DO.",
    },

    error: {
        cancel_dp: "Failed to cancel down payment (DP).",
        create: "Failed to create PO.",
        create_do: "Failed to create goods receipt reference (DO IN).",
        create_dp: "Failed to process down payment.",
        delete: "Failed to cancel PO.",
        edit: "Failed to update PO.",

        reject: "Failed to cancel PO.",
        approve: "Failed to confirm PO.",
        done: "Failed to complete PO.",
    },

    success: {
        cancel_dp: "Down payment (DP) cancelled successfully.",
        create: "PO created successfully.",
        create_do: "Goods receipt reference (DO IN) created successfully.",
        create_dp: "Down payment processed successfully.",
        delete: "PO cancelled successfully.",
        edit: "PO updated successfully.",

        reject: "PO cancelled successfully.",
        approve: "PO confirmed successfully.",
        done: "PO completed successfully.",
    },
}

export default en_purch_po;